module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-block"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "header-block--right"
  }, [_c('a', {
    on: {
      "click": _vm.toggleOverlay
    }
  }, [_vm._v("\n            Contact\n        ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-block--left"
  }, [_c('h1', {
    staticClass: "header-block--title"
  }, [_vm._v("\n            John Horjus\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "header-block--undertitle"
  }, [_vm._v("\n            Freelance creative/director\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a0a08588!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeaderBlock.vue
// module id = 16
// module chunks = 1